import type { CartItem } from "@/lib/bagisto/types";
import CartRow from "@/components/add-to-cart/cart-row";

interface CartTableProps {
    items: CartItem[];
    currencyCode: string;
    onRemove: (id: string) => void;
    onDecrement: (item: CartItem) => void;
    onIncrement: (item: CartItem) => void;
    isUpdateLoading: boolean;
    isRemoveLoading: boolean;
}

export default function CartTable({
    items,
    currencyCode,
    onRemove,
    onDecrement,
    onIncrement,
    isUpdateLoading,
    isRemoveLoading,
}: CartTableProps) {
    return (
        <div className="w-full py-[75px] flex flex-col gap-6">

            {/* Top Border */}
            <div className="w-screen relative -left-4 sm:-left-6 lg:-left-10 border-t border-stroke-light" />

            {/* Table Header */}
            <div className="hidden md:flex items-center gap-30">
                {["Products", "Price", "Quantity", "Subtotal"].map((col) => (
                    <span
                        key={col}
                        className="w-[219px] h-6 font-oswald font-medium text-[16px] leading-[100%] tracking-[0.2px] uppercase text-neutral-500"
                    >
                        {col}
                    </span>
                ))}
            </div>

            {/* Bottom Border of Header */}
            <div className="w-screen relative -left-4 sm:-left-6 lg:-left-10 border-t border-stroke-light" />

            {/* Table Rows */}
            {items.map((item: CartItem) => (
                <CartRow
                    key={item.id}
                    item={item}
                    currencyCode={currencyCode}
                    onRemove={onRemove}
                    onDecrement={onDecrement}
                    onIncrement={onIncrement}
                    isUpdateLoading={isUpdateLoading}
                    isRemoveLoading={isRemoveLoading}
                />
            ))}
        </div>
    );
}